import { render, staticRenderFns } from "./FormSelector.vue?vue&type=template&id=77c76d16"
import script from "./FormSelector.vue?vue&type=script&lang=js"
export * from "./FormSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports